import { render } from "./sw-filterable-select.vue?vue&type=template&id=50fdc9d2&scoped=true"
import script from "./sw-filterable-select.vue?vue&type=script&lang=js"
export * from "./sw-filterable-select.vue?vue&type=script&lang=js"

import "./sw-filterable-select.vue?vue&type=style&index=0&id=50fdc9d2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fdc9d2"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QIcon});
